import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { InsuranceService } from '@APP/services/insurance-service';
import { QuestionsService } from '@APP/services/questions-service';
import { t } from '@APP/utils/locale';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { Skipper, Admiral, Captain } from '../icons/icons';

type deps = {
  insuranceService: InsuranceService;
  questionsService: QuestionsService;
};
@requires(QuestionsService.serviceName, InsuranceService.serviceName)
@customElement('boat-details-min-buy-now-error-popup')
export class BoatDetailsValueWarningPopup extends DepInjMixin<deps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
      .title {
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
      margin-top: 0;
    }
    .icon svg { 
      width: 28.75rem;
      height: 28.75rem;
      margin-right: 3.75rem;
      place-self: center start;
    }
    :host {
      max-width: 60rem
    }

    h2 { 
      margin-block-end: 3rem;
    }
     `,
    ];
  };

  static get mobileStyles() {
    return [
      commonPopupMobileStyle,
      css`
      svg, img{
        max-width:22.5rem;
        max-height:22.5rem;
        margin:2rem 0;
      }
    `,
    ];};

  @property({ type: String })
    value: string = '';

  @state()
    img: any;

  setImg(packageName: string) {
    switch (packageName) {
      case 'Skipper':
        return Skipper;
      case 'Admiral':
        return Admiral;
      case 'Captain':
        return Captain;
    }
    return;
  }

  renderMobileLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1">
        <h2 class="message">${t('T_Boat_Details_Min_Value_Buy_Now_Button_Err')}</h2>
       </div>
       <div class="col-2"></div>
      <div class="col-3"></div>
     </div>
    `;
  }

  renderDesktopLayout() {
    const supportNumber = this.deps.questionsService.model.getSupportPhoneNumberText();
    const supportNumberWithoutBrHtml = supportNumber.replace('<br>', '');
    return html`
      <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2 min-height">
        <h2 class="message">${t('T_Boat_Details_Min_Value_Warning_Popup',supportNumberWithoutBrHtml)}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
